// The design-system base must be the first stylesheet in the bundle: CSS lands in import order, and App's
// imports pull in component styles (e.g. .btn-lg in site.css) that need to override its .btn defaults.
import './brand/nocturne.css';
import App from './App.tsx';
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';

const queryClient = new QueryClient();

const Root = () => (
    <QueryClientProvider client={queryClient}>
        <StrictMode>
            <BrowserRouter basename="/">
                <App />
            </BrowserRouter>
        </StrictMode>
    </QueryClientProvider>
);

export default Root;
